import { Provider } from 'react-redux'
import NavLayout from './Screens/NavLayout'
import { store } from './Store'

export default function App() {
  return (
    <Provider store={store}>
      <NavLayout />
    </Provider>
  )
}
